export default defineNuxtRouteMiddleware(() => {
  const { $switchRoute } = useI18n()

  if (!useUser().isAdmin)
    return $switchRoute('/')
})
